import React from 'react';

import { GridLegacy as Grid } from '@mui/material';

import { operations } from '@luxuryescapes/contract-svc-promo';

import BorderedGridItem from '~/components/Common/BorderedGridItem';

import { sortPromoItemByCategoryAndId } from '~/services/PromoService';

import { PromoResponseItem } from './PromoResponseItem';

type PromoOrderTableCellProps = {
  response: operations['calculateDiscount']['responses']['200']['content']['application/json'];
  isDev: boolean;
};

function PromoResponse({ response, isDev }: PromoOrderTableCellProps) {
  if (!response || !response.result || !response.result.promo) {
    return null;
  }

  const { promo } = response.result;

  const { items } = promo;

  return (
    <Grid container>
      {items.sort(sortPromoItemByCategoryAndId).map((item, i) => (
        <BorderedGridItem key={`${item.offerId || item.itemId}_${i}`}>
          <PromoResponseItem key={`${item.offerId || item.itemId}_${i}`} item={item} currencyCode={promo.currency} />
        </BorderedGridItem>
      ))}
    </Grid>
  );
}

export { PromoResponse };
